.page {
  width: 100%;
  max-width: 92.8rem;
  margin: 0 auto;
  padding: 1.6rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 1.6rem;
}

.footer {
  margin-top: 1.6rem;
}
